import { createGlobalState } from 'react-use';
import { useCallback } from 'react';

import { AudioInputDevice } from '../audio/audioInputDevices';

type AiAssistantMicrophoneGlobalState = {
   device: AudioInputDevice | null;
};

const useGlobalState = createGlobalState<AiAssistantMicrophoneGlobalState>({ device: null });

type SetDeviceCallback = (device: AudioInputDevice | null) => void;

type UseAiAssistantMicrophoneGlobalStateReturnFn = {
   device: AudioInputDevice | null;
   setDevice: SetDeviceCallback;
};

export const useAiAssistantMicrophoneGlobalState = (): UseAiAssistantMicrophoneGlobalStateReturnFn => {
   const [state, setState] = useGlobalState();

   const setDevice = useCallback<SetDeviceCallback>(
      (device) => {
         setState((prev) => (prev.device?.id === device?.id ? prev : { device: device }));
      },
      [setState]
   );

   return {
      device: state.device,
      setDevice: setDevice,
   };
};
